import React, { Fragment, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SideBar from "./SideBar";
import NavHader from "./NavHader";
import Header from "./Header";
import ChatBox from "../ChatBox";

const JobieNav = ({ title, onClick: ClickToAddEvent, onClick2, onClick3 }) => {
  const [toggle, setToggle] = useState("");
  const onClick = (name) => setToggle(toggle === name ? "" : name);
  const location = useLocation();

  useEffect(() => {
    const contentBody = document.querySelector(".content-body");
    const mainWrapper = document.querySelector(".main-wrapper");
    const navHeader = document.querySelector(".nav-header");

    if (location.pathname === "/pos") {
      // Hide all top + side spacing when on POS page
      if (contentBody) {
        contentBody.style.marginTop = "0";
        contentBody.style.paddingTop = "0";
        contentBody.style.marginLeft = "0";
      }
      if (mainWrapper) {
        mainWrapper.style.marginTop = "0";
        mainWrapper.style.paddingTop = "0";
        mainWrapper.style.marginLeft = "0";
      }
      if (navHeader) {
        navHeader.style.display = "none";
      }
    } else {
      // Restore layout for normal pages
      if (contentBody) {
        contentBody.style.marginTop = "";
        contentBody.style.paddingTop = "";
        contentBody.style.marginLeft = "";
      }
      if (mainWrapper) {
        mainWrapper.style.marginTop = "";
        mainWrapper.style.paddingTop = "";
        mainWrapper.style.marginLeft = "";
      }
      if (navHeader) {
        navHeader.style.display = "";
      }
    }
  }, [location.pathname]);

  // ✅ Hide Header + Sidebar components for POS
  const hideForPOS = location.pathname === "/pos";

  return (
    <Fragment>
      {!hideForPOS && <NavHader />}
      {!hideForPOS && <ChatBox onClick={() => onClick("chatbox")} toggle={toggle} />}
      {!hideForPOS && (
        <Header
          onNote={() => onClick("chatbox")}
          onNotification={() => onClick("notification")}
          onProfile={() => onClick("profile")}
          toggle={toggle}
          title={title}
          onBox={() => onClick("box")}
          onClick={() => ClickToAddEvent()}
        />
      )}
      {!hideForPOS && <SideBar />}
    </Fragment>
  );
};

export default JobieNav;
